import { render, staticRenderFns } from "./UserRideTypeWaitTimeList.vue?vue&type=template&id=2eeda7a0&scoped=true&"
import script from "./UserRideTypeWaitTimeList.vue?vue&type=script&lang=js&"
export * from "./UserRideTypeWaitTimeList.vue?vue&type=script&lang=js&"
import style0 from "./UserRideTypeWaitTimeList.vue?vue&type=style&index=0&id=2eeda7a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeda7a0",
  null
  
)

export default component.exports